<template>
  <div>
    <h2 class="text-center text-[28px] font-semibold">密码登录</h2>
    <p class="mt-[4px] text-center text-base">请使用邮箱/手机、密码登录</p>
    <Form class="my-6 password-form" @submit.prevent="onClickLogin">
      <FormItem>
        <Input v-model="identity" size="large" placeholder="手机/邮箱" class="password-form-input"></Input>
      </FormItem>
      <FormItem>
        <div class="relative">
          <input v-model="password" type="password" placeholder="密码" class="ivu-input h-[48px] rounded-md pr-[96px]" />
          <div class="absolute top-[0px] right-[20px] leading-[48px] cursor-pointer text-primary-main" @click="router.push({ name: 'forget' })">忘记密码</div>
        </div>
      </FormItem>
      <FormItem v-if="enabled2FA">
        <Input v-model="token" placeholder="二步验证码"></Input>
      </FormItem>
      <FormItem v-if="error" class="min-h-0">
        <Alert type="error" show-icon class="m-0">{{ error }}</Alert>
      </FormItem>
      <FormItem>
        <Button @click="onClickLogin" html-type="submit" type="primary" size="large" long class="h-12 rounded-md">登&nbsp;&nbsp;录</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
// TODO vuex typings
// @ts-ignore
import { useStore } from 'vuex';
import getErrorMessage from '@/utils/get-error-message';
import trackEvent from '@/utils/track-event';
import useLoginCheck from '@/composables/login-check.ts';

const router = useRouter();

const identity = ref('');
const password = ref('');
const token = ref('');
const enabled2FA = ref(false);
const error = ref('');

const onClickLogin = async () => {
  const payload: { [key: string]: string } = {
    identity: identity.value,
    password: password.value
  };
  if (enabled2FA) {
    payload.otpToken = token.value;
  }
  try {
    const { data } = await axios.post('/api/auth/loginByPassword', payload);
    if (data?.code === 4) {
      error.value = data?.message || '';
    }
    trackEvent('click_register', 'password', 'community');
    useLoginCheck();
  } catch (e: any) {
    const code = e?.response?.data ? e.response.data.code : -1;
    if (code === 2) enabled2FA.value = true;
    else error.value = getErrorMessage(e);
  }
};
</script>

<style lang="scss">
.password-form {
  .ivu-form-item {
    margin-bottom: 16px;
  }
  .ivu-input-wrapper {
    input {
      border-radius: 6px;
      height: 48px !important;
    }
  }
  .forget-password {
    position: absolute;
  }
}
</style>
